import { GlobalAdmin } from "coolremote-sdk";

// The SDK's xhr layer already reduces the API envelope to its inner `data`, so these
// resolve straight to the list / audit objects (see DeviceSync/deviceSyncApi.ts).

export interface IPagingOptions {
  pageNum: number;
  pageSize: number;
}

export interface IPagedAudits<T = any> {
  totalCount: number;
  totalPages: number;
  pageSize: number;
  page: number;
  sort: string[];
  audits: T[];
}

export function getDeviceConnections(deviceId: string, options: IPagingOptions): Promise<IPagedAudits> {
  return GlobalAdmin.getDeviceConnections(deviceId, options);
}

export function getDeviceTelemetryRecoveryAudits(
  deviceId: string,
  options: IPagingOptions
): Promise<IPagedAudits> {
  return GlobalAdmin.getDeviceTelemetryRecoveryAudits(deviceId, options);
}

export function getDeviceTelemetryRecoveryAudit(deviceId: string, auditId: string): Promise<any> {
  return GlobalAdmin.getDeviceTelemetryRecoveryAudit(deviceId, auditId);
}
